import lazyWithPreload from 'config/lazy-with-preloading';
import AuthGuard from 'modules/shared/components/AuthGuard/AuthGuard';
import { useEffect } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

const AllUnits = lazyWithPreload(() => import('./pages/Dashboard/AllLiveUnits'));
const LiveUnitDetail = lazyWithPreload(() => import('./pages/LiveUnitDetail/LiveUnitDetail'));

const LiveUnitManagementRouter = () => {
    useEffect(() => {
        AllUnits.preload();
        LiveUnitDetail.preload();
    }, []);

    const routes = useRoutes([
        {
            path: '/',
            element: (
                <AuthGuard>
                    <AllUnits />
                </AuthGuard>
            ),
        },
        {
            path: '/:liveUnitId',
            element: (
                <AuthGuard>
                    <LiveUnitDetail />
                </AuthGuard>
            ),
        },
        {
            path: '*',
            element: <Navigate replace to="/404" />,
        },
    ]);

    return routes;
};

export default LiveUnitManagementRouter;
